/**
 * BOQ (Bill of Quantities) Data Service
 * Provides baseline mock data matching the UI designs and localStorage persistence.
 */

const STORAGE_KEY = "erp_works_boq_list";

export const initialBOQList = [
  {
    Id: "boq-1",
    BOQNo: "BOQ-2026-001",
    BOQName: "Structural Works",
    DraftedBy: "Engr. Faisal",
    Project: "ADF Colony",
    BuildingPhase: "Tower A",
    Version: "V1",
    Amount: 25400000,
    AwardedValue: 15600000,
    Status: "Draft",
    CreatedDate: "17 Jul 2026",
    LastUpdated: "17 Jul 2026 12:43 PM",
    ContingencyPct: 5,
    Sections: [
      {
        id: "sec-a",
        title: "A. Earthworks",
        items: [
          {
            id: "item-a1",
            itemCode: "A.1",
            description: "Excavation for foundations",
            specification: "As per drawing and geotechnical report",
            qty: 500,
            unit: "Cft",
            unitRate: 800,
            amount: 400000,
            rateSource: "Library",
            consumptions: [],
          },
          {
            id: "item-a2",
            itemCode: "A.2",
            description: "Backfilling with selected material",
            specification: "Compaction in layers",
            qty: 250,
            unit: "Cft",
            unitRate: 1200,
            amount: 300000,
            rateSource: "Library",
            consumptions: [],
          },
        ],
      },
      {
        id: "sec-b",
        title: "B. Concrete Works",
        items: [
          {
            id: "item-b1",
            itemCode: "B.1",
            description: "PCC (1:4:8)",
            specification: "50mm thick, on foundations and level surfaces as specified",
            qty: 100,
            unit: "Cft",
            unitRate: 12000,
            amount: 1200000,
            rateSource: "Library",
            consumptions: [
              {
                id: "c-1",
                materialId: "MAT-CIV-0021",
                materialName: "MAT-CIV-0021 (Bestway Cement)",
                baseQty: 9.5,
                unit: "Bags",
                wastagePct: 2,
                totalReq: 9.69,
              },
              {
                id: "c-2",
                materialId: "MAT-CIV-0033",
                materialName: "MAT-CIV-0033 (Sand / Chenab)",
                baseQty: 40,
                unit: "Cft",
                wastagePct: 5,
                totalReq: 42.0,
              },
              {
                id: "c-3",
                materialId: "MAT-CIV-0034",
                materialName: "MAT-CIV-0034 (Crushed Stone / Bajri)",
                baseQty: 80,
                unit: "Cft",
                wastagePct: 4,
                totalReq: 83.2,
              },
            ],
          },
          {
            id: "item-b2",
            itemCode: "B.2",
            description: "RCC (M20)",
            specification: "As per structural drawings",
            qty: 200,
            unit: "Cft",
            unitRate: 25000,
            amount: 5000000,
            rateSource: "Library",
            consumptions: [
              {
                id: "c-4",
                materialId: "MAT-CIV-0021",
                materialName: "MAT-CIV-0021 (Bestway Cement)",
                baseQty: 28,
                unit: "Bags",
                wastagePct: 2,
                totalReq: 28.56,
              },
              {
                id: "c-5",
                materialId: "MAT-CIV-0033",
                materialName: "MAT-CIV-0033 (Sand / Chenab)",
                baseQty: 50,
                unit: "Cft",
                wastagePct: 5,
                totalReq: 52.5,
              },
              {
                id: "c-6",
                materialId: "MAT-CIV-0034",
                materialName: "MAT-CIV-0034 (Crushed Stone / Bajri)",
                baseQty: 100,
                unit: "Cft",
                wastagePct: 4,
                totalReq: 104.0,
              },
              {
                id: "c-7",
                materialId: "MAT-CIV-0015",
                materialName: 'MAT-CIV-0015 (Deformed Bar 1/2" G60)',
                baseQty: 1.8,
                unit: "Ton",
                wastagePct: 3,
                totalReq: 1.85,
              },
            ],
          },
        ],
      },
      {
        id: "sec-c",
        title: "C. Masonry Works",
        items: [
          {
            id: "item-c1",
            itemCode: "C.1",
            description: "Brick Masonry (1:4)",
            specification: '9" thick brickwork in cement mortar',
            qty: 100,
            unit: "Sft",
            unitRate: 21000,
            amount: 2100000,
            rateSource: "Manual",
            consumptions: [
              {
                id: "c-8",
                materialId: "MAT-CIV-0008",
                materialName: "MAT-CIV-0008 (Red Bricks Class A)",
                baseQty: 1350,
                unit: "Nos",
                wastagePct: 3,
                totalReq: 1390.5,
              },
              {
                id: "c-9",
                materialId: "MAT-CIV-0021",
                materialName: "MAT-CIV-0021 (Bestway Cement)",
                baseQty: 4.5,
                unit: "Bags",
                wastagePct: 2,
                totalReq: 4.59,
              },
            ],
          },
        ],
      },
      {
        id: "sec-d",
        title: "D. Metal & Structural Steel",
        items: [
          {
            id: "item-d1",
            itemCode: "D.1",
            description: "Mild steel fabrication and fixing",
            specification: "Pre-fabricated steel sections with anti-rust primer",
            qty: 12,
            unit: "Ton",
            unitRate: 350000,
            amount: 4200000,
            rateSource: "Library",
            consumptions: [],
          },
        ],
      },
      {
        id: "sec-e",
        title: "E. Waterproofing & Insulation",
        items: [
          {
            id: "item-e1",
            itemCode: "E.1",
            description: "Bituminous membrane waterproofing",
            specification: "4mm torch-applied membrane on foundation raft",
            qty: 850,
            unit: "Sft",
            unitRate: 1400,
            amount: 1190000,
            rateSource: "Library",
            consumptions: [],
          },
        ],
      },
      {
        id: "sec-f",
        title: "F. Underground Drainage & Sewerage",
        items: [
          {
            id: "item-f1",
            itemCode: "F.1",
            description: 'RCC Pipes 9" dia class B',
            specification: "Rubber ring joints with bed concrete",
            qty: 320,
            unit: "Rft",
            unitRate: 31562.5,
            amount: 10100000,
            rateSource: "Library",
            consumptions: [],
          },
        ],
      },
    ],
  },
  {
    Id: "boq-2",
    BOQNo: "BOQ-2026-002",
    BOQName: "Finishing Works",
    DraftedBy: "Engr. Faisal",
    Project: "ADF Colony",
    BuildingPhase: "Tower B",
    Version: "V1",
    Amount: 12500000,
    AwardedValue: 6200000,
    Status: "Draft",
    CreatedDate: "12 Jul 2026",
    LastUpdated: "15 Jul 2026 04:15 PM",
    ContingencyPct: 5,
    Sections: [
      {
        id: "sec-fin-1",
        title: "A. Floor & Wall Tiles",
        items: [
          {
            id: "fin-item-1",
            itemCode: "A.1",
            description: "Porcelain tiles 60x60cm",
            specification: "High traffic porcelain tiles with adhesive bond",
            qty: 2500,
            unit: "Sft",
            unitRate: 3200,
            amount: 8000000,
            rateSource: "Library",
            consumptions: [],
          },
          {
            id: "fin-item-2",
            itemCode: "A.2",
            description: "Skirting 100mm high",
            specification: "Matching tile skirting on walls",
            qty: 1500,
            unit: "Rft",
            unitRate: 3000,
            amount: 4500000,
            rateSource: "Library",
            consumptions: [],
          },
        ],
      },
    ],
  },
  {
    Id: "boq-3",
    BOQNo: "BOQ-2026-003",
    BOQName: "External Development",
    Project: "Green City",
    BuildingPhase: "Phase 1",
    Version: "V1",
    Amount: 8200000,
    AwardedValue: 4100000,
    Status: "Pending Approval",
    CreatedDate: "05 Jul 2026",
    LastUpdated: "10 Jul 2026 09:30 AM",
    ContingencyPct: 5,
    Sections: [
      {
        id: "sec-ext-1",
        title: "A. Road Works & Curbs",
        items: [
          {
            id: "ext-item-1",
            itemCode: "A.1",
            description: "Precast Concrete Kerb Stones",
            specification: "Class 1 hydraulic pressed kerb stones 300x150mm",
            qty: 1200,
            unit: "Rft",
            unitRate: 6833.33,
            amount: 8200000,
            rateSource: "Library",
            consumptions: [],
          },
        ],
      },
    ],
  },
  {
    Id: "boq-4",
    BOQNo: "BOQ-2026-004",
    BOQName: "Electrical & Plumbing (MEP)",
    DraftedBy: "Engr. Faisal",
    Project: "Gulberg Heights",
    BuildingPhase: "Tower A - MEP",
    Version: "V1",
    Amount: 45200000,
    AwardedValue: 20000000,
    Status: "Draft",
    CreatedDate: "02 Jul 2026",
    LastUpdated: "08 Jul 2026 11:20 AM",
    ContingencyPct: 5,
    Sections: [
      {
        id: "sec-mep-1",
        title: "A. Electrical Risers & Conduit",
        items: [
          {
            id: "mep-item-1",
            itemCode: "A.1",
            description: "GI Conduiting & Cable Tray",
            specification: "Heavy gauge hot-dip galvanized cable trays with bends",
            qty: 1800,
            unit: "Rft",
            unitRate: 25111.11,
            amount: 45200000,
            rateSource: "Library",
            consumptions: [],
          },
        ],
      },
    ],
  },
  {
    Id: "boq-5",
    BOQNo: "BOQ-2026-005",
    BOQName: "Earthworks & Foundation",
    AssignedTo: "Chief Auditor",
    Project: "River View Suites",
    BuildingPhase: "Block C",
    Version: "V3",
    Amount: 3450000,
    AwardedValue: 3450000,
    Status: "Approved",
    CreatedDate: "20 Jun 2026",
    LastUpdated: "17 Jul 2026 12:43 PM",
    ContingencyPct: 5,
    Sections: [
      {
        id: "sec-rv-1",
        title: "A. Deep Excavation",
        items: [
          {
            id: "rv-item-1",
            itemCode: "A.1",
            description: "Bulk Excavation in gravel",
            specification: "Machine excavation up to 15ft depth",
            qty: 1500,
            unit: "Cft",
            unitRate: 2300,
            amount: 3450000,
            rateSource: "Library",
            consumptions: [],
          },
        ],
      },
    ],
  },
  {
    Id: "boq-6",
    BOQNo: "BOQ-2026-006",
    BOQName: "Finishing & Interlock",
    DraftedBy: "Engr. Faisal",
    Project: "Faisal Gated Community",
    BuildingPhase: "Main Boulevard",
    Version: "V1",
    Amount: 7800000,
    AwardedValue: 0,
    Status: "Rejected / Revisions Needed",
    CreatedDate: "15 Jun 2026",
    LastUpdated: "25 Jun 2026 03:10 PM",
    ContingencyPct: 5,
    Sections: [
      {
        id: "sec-fg-1",
        title: "A. Paver Tiles",
        items: [
          {
            id: "fg-item-1",
            itemCode: "A.1",
            description: "Tough Pavers 60mm 5000 PSI",
            specification: "Color pigmented concrete interlocking paving blocks",
            qty: 39000,
            unit: "Sft",
            unitRate: 200,
            amount: 7800000,
            rateSource: "Library",
            consumptions: [],
          },
        ],
      },
    ],
  },
];

// Predefined Rate Library Activities for the Drawer
export const rateLibraryActivities = [
  {
    id: "act-1",
    name: "PCC (1:4:8) - Concrete Works",
    section: "B. Concrete Works",
    itemCode: "B.1",
    description: "PCC (1:4:8)",
    specification: "50mm thick, on foundations and level surfaces as specified",
    unit: "Cft",
    unitRate: 12000,
    rateSource: "Library",
    consumptions: [
      {
        materialId: "MAT-CIV-0021",
        materialName: "MAT-CIV-0021 (Bestway Cement)",
        baseQty: 9.5,
        unit: "Bags",
        wastagePct: 2,
        totalReq: 9.69,
      },
      {
        materialId: "MAT-CIV-0033",
        materialName: "MAT-CIV-0033 (Sand / Chenab)",
        baseQty: 40,
        unit: "Cft",
        wastagePct: 5,
        totalReq: 42.0,
      },
      {
        materialId: "MAT-CIV-0034",
        materialName: "MAT-CIV-0034 (Crushed Stone / Bajri)",
        baseQty: 80,
        unit: "Cft",
        wastagePct: 4,
        totalReq: 83.2,
      },
    ],
  },
  {
    id: "act-2",
    name: "RCC (M20) - Concrete Works",
    section: "B. Concrete Works",
    itemCode: "B.2",
    description: "RCC (M20)",
    specification: "As per structural drawings with reinforced steel",
    unit: "Cft",
    unitRate: 25000,
    rateSource: "Library",
    consumptions: [
      {
        materialId: "MAT-CIV-0021",
        materialName: "MAT-CIV-0021 (Bestway Cement)",
        baseQty: 28,
        unit: "Bags",
        wastagePct: 2,
        totalReq: 28.56,
      },
      {
        materialId: "MAT-CIV-0033",
        materialName: "MAT-CIV-0033 (Sand / Chenab)",
        baseQty: 50,
        unit: "Cft",
        wastagePct: 5,
        totalReq: 52.5,
      },
      {
        materialId: "MAT-CIV-0034",
        materialName: "MAT-CIV-0034 (Crushed Stone / Bajri)",
        baseQty: 100,
        unit: "Cft",
        wastagePct: 4,
        totalReq: 104.0,
      },
      {
        materialId: "MAT-CIV-0015",
        materialName: 'MAT-CIV-0015 (Deformed Bar 1/2" G60)',
        baseQty: 1.8,
        unit: "Ton",
        wastagePct: 3,
        totalReq: 1.85,
      },
    ],
  },
  {
    id: "act-3",
    name: "Excavation for foundations - Earthworks",
    section: "A. Earthworks",
    itemCode: "A.1",
    description: "Excavation for foundations",
    specification: "As per drawing and geotechnical report",
    unit: "Cft",
    unitRate: 800,
    rateSource: "Library",
    consumptions: [],
  },
  {
    id: "act-4",
    name: "Backfilling with selected material - Earthworks",
    section: "A. Earthworks",
    itemCode: "A.2",
    description: "Backfilling with selected material",
    specification: "Compaction in layers",
    unit: "Cft",
    unitRate: 1200,
    rateSource: "Library",
    consumptions: [],
  },
  {
    id: "act-5",
    name: "Brick Masonry (1:4) - Masonry Works",
    section: "C. Masonry Works",
    itemCode: "C.1",
    description: "Brick Masonry (1:4)",
    specification: '9" thick brickwork in cement mortar',
    unit: "Sft",
    unitRate: 21000,
    rateSource: "Library",
    consumptions: [
      {
        materialId: "MAT-CIV-0008",
        materialName: "MAT-CIV-0008 (Red Bricks Class A)",
        baseQty: 1350,
        unit: "Nos",
        wastagePct: 3,
        totalReq: 1390.5,
      },
      {
        materialId: "MAT-CIV-0021",
        materialName: "MAT-CIV-0021 (Bestway Cement)",
        baseQty: 4.5,
        unit: "Bags",
        wastagePct: 2,
        totalReq: 4.59,
      },
    ],
  },
  {
    id: "act-6",
    name: "Plaster (1:4) Internal - Finishing",
    section: "D. Finishing Works",
    itemCode: "D.1",
    description: "Plaster (1:4) Internal",
    specification: "12mm thick cement sand plaster on walls and ceilings",
    unit: "Sft",
    unitRate: 650,
    rateSource: "Library",
    consumptions: [
      {
        materialId: "MAT-CIV-0021",
        materialName: "MAT-CIV-0021 (Bestway Cement)",
        baseQty: 1.2,
        unit: "Bags",
        wastagePct: 3,
        totalReq: 1.24,
      },
      {
        materialId: "MAT-CIV-0033",
        materialName: "MAT-CIV-0033 (Sand / Chenab)",
        baseQty: 4.8,
        unit: "Cft",
        wastagePct: 5,
        totalReq: 5.04,
      },
    ],
  },
];

// Available Materials SKU list for Tab 2
export const stockMaterialsList = [
  { id: "MAT-CIV-0021", label: "MAT-CIV-0021 (Bestway Cement)", unit: "Bags", defaultWastage: 2 },
  { id: "MAT-CIV-0033", label: "MAT-CIV-0033 (Sand / Chenab)", unit: "Cft", defaultWastage: 5 },
  {
    id: "MAT-CIV-0034",
    label: "MAT-CIV-0034 (Crushed Stone / Bajri)",
    unit: "Cft",
    defaultWastage: 4,
  },
  {
    id: "MAT-CIV-0015",
    label: 'MAT-CIV-0015 (Deformed Bar 1/2" G60)',
    unit: "Ton",
    defaultWastage: 3,
  },
  {
    id: "MAT-CIV-0008",
    label: "MAT-CIV-0008 (Red Bricks Class A)",
    unit: "Nos",
    defaultWastage: 3,
  },
  {
    id: "MAT-FIN-0045",
    label: "MAT-FIN-0045 (Porcelain Tiles 60x60)",
    unit: "Sft",
    defaultWastage: 5,
  },
  {
    id: "MAT-FIN-0012",
    label: "MAT-FIN-0012 (Weather Shield Paint)",
    unit: "Gallon",
    defaultWastage: 2,
  },
  {
    id: "MAT-ELE-0005",
    label: 'MAT-ELE-0005 (PVC Conduit Pipe 1")',
    unit: "Rft",
    defaultWastage: 4,
  },
];

/**
 * Retrieve all BOQs from localStorage (or seed baseline if empty)
 */
export const getBOQList = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(initialBOQList));
      return initialBOQList;
    }
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed) || parsed.length === 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(initialBOQList));
      return initialBOQList;
    }
    return parsed;
  } catch (err) {
    console.error("Error loading BOQs from localStorage:", err);
    return initialBOQList;
  }
};

/**
 * Retrieve a single BOQ by ID or BOQ Number
 */
export const getBOQById = (idOrNo) => {
  const list = getBOQList();
  return list.find((b) => b.Id === idOrNo || b.BOQNo === idOrNo) || null;
};

/**
 * Generate next BOQ Number
 */
export const generateNextBOQNo = () => {
  const list = getBOQList();
  const year = new Date().getFullYear();
  let maxSeq = 0;
  list.forEach((b) => {
    const match = String(b.BOQNo || "").match(/BOQ-\d{4}-(\d+)/);
    if (match) {
      const num = parseInt(match[1], 10);
      if (!isNaN(num) && num > maxSeq) {
        maxSeq = num;
      }
    }
  });
  const nextSeq = String(maxSeq + 1).padStart(3, "0");
  return `BOQ-${year}-${nextSeq}`;
};

/**
 * Save or update a BOQ
 */
export const saveBOQ = (boqData) => {
  const list = getBOQList();
  const id = boqData.Id || `boq-${Date.now()}`;
  const now = new Date();
  const dateStr = now.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  const timeStr = now.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });

  // Compute total base amount from all section items
  let totalBaseAmount = 0;
  (boqData.Sections || []).forEach((sec) => {
    (sec.items || []).forEach((item) => {
      const itemAmt = Number(item.amount) || Number(item.qty || 0) * Number(item.unitRate || 0);
      totalBaseAmount += itemAmt;
    });
  });

  const record = {
    ...boqData,
    Id: id,
    BOQNo: boqData.BOQNo || generateNextBOQNo(),
    Amount: totalBaseAmount,
    CreatedDate: boqData.CreatedDate || dateStr,
    LastUpdated: `${dateStr} ${timeStr}`,
    Status: boqData.Status || "Draft",
  };

  const existingIdx = list.findIndex((b) => b.Id === id || b.BOQNo === record.BOQNo);
  let updatedList;
  if (existingIdx >= 0) {
    updatedList = [...list];
    updatedList[existingIdx] = record;
  } else {
    updatedList = [record, ...list];
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedList));
  return record;
};

/**
 * Delete a BOQ
 */
export const deleteBOQ = (id) => {
  const list = getBOQList();
  const updated = list.filter((b) => b.Id !== id && b.BOQNo !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  return updated;
};

/**
 * Update BOQ status
 */
export const updateBOQStatus = (id, newStatus) => {
  const list = getBOQList();
  const now = new Date();
  const dateStr = now.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  const timeStr = now.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });

  const updated = list.map((b) => {
    if (b.Id === id || b.BOQNo === id) {
      return {
        ...b,
        Status: newStatus,
        LastUpdated: `${dateStr} ${timeStr}`,
      };
    }
    return b;
  });

  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  return updated;
};
